import { render } from "./ComLogoutButton.vue?vue&type=template&id=d4a6ecaa&ts=true"
import script from "./ComLogoutButton.vue?vue&type=script&lang=ts"
export * from "./ComLogoutButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__